// extracted by mini-css-extract-plugin
module.exports = {"reviews":"reviews-1Fnlr","empty":"empty-3AWTc"};